import React from 'react'
import PropTypes from 'prop-types'
import circleIcon from '../../asset/circle.svg'
import LockIcon from '../../asset/lock.svg'
import { useNavigate } from 'react-router-dom'

import {
  LoadingContainer,
  IconWrapper,
  CircleIcon,
  CenterIcon,
  LoadingPageContent,
  PageTitle,
  PageSubtitle,
} from './styles'

const LoadingPageCard = ({ centerIcon, title, subtitle, redirectPath }) => {
  const navigate = useNavigate()
  if (redirectPath) {
    if (title || subtitle) {
      setTimeout(() => navigate(redirectPath), 7000)
    } else {
      setTimeout(() => navigate(redirectPath), 3000)
    }
  }
  return (
    <LoadingContainer>
      <IconWrapper>
        <CircleIcon src={circleIcon} alt="" />
        <CenterIcon src={centerIcon || LockIcon} alt="" />
      </IconWrapper>
      {(title || subtitle) && (
        <LoadingPageContent aria-live="polite">
          <PageTitle>{title}</PageTitle>
          <PageSubtitle>{subtitle}</PageSubtitle>
        </LoadingPageContent>
      )}
    </LoadingContainer>
  )
}

LoadingPageCard.propTypes = {
  centerIcon: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  redirectPath: PropTypes.string,
}

export default LoadingPageCard
